import BaseDataObject from './BaseDataObject';
import BetKey from './BetKey';
import Stake from './Stake';
import Track from './Track';

export default class SavedBetSet extends BaseDataObject {
  constructor(data) {
    super(Array.isArray(data) ? { savedBets: data } : data);
  }

  getNumberOfSavedBets() {
    return this.getNumberOf('savedBets');
  }

  getSavedBet(index) {
    return this.getObject('savedBets', SavedBet, index);
  }
}

class SavedBet extends BaseDataObject {
  getID() {
    return this.getInteger('id');
  }

  getStake() {
    return this.getObject('stake', Stake);
  }

  getTrack() {
    return this.getObject('track', Track);
  }

  getBetKey() {
    return this.getObject('betKey', BetKey);
  }

  getName() {
    return this.getString('name');
  }

  getCreatedTime() {
    return this.getDate('createdAt');
  }

  getModifiedTime() {
    return this.getDate('modifiedAt');
  }

  isOwned() {
    return this.getBoolean('isOwned');
  }

  isShared() {
    return this.getBoolean('isShared');
  }
}
